(() => {
  class MMStickyATC extends HTMLElement {
    connectedCallback() {
      if (this.closest('quick-add-modal')) return;
      this.product = document.getElementById(this.dataset.productInfoId);
      this.nativeButton = this.product?.querySelector('.product-form__submit');
      if (!this.nativeButton) return;
      this.button = this.querySelector('[data-sticky-button]');
      const sync = () => {
        const choosing = this.nativeButton.dataset.mmExplicitChoice === 'true' && this.product.dataset.mmChoiceMade !== 'true';
        const disabled = !choosing && (this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true');
        if (this.button.disabled !== disabled) this.button.disabled = disabled;
        const label = this.nativeButton.querySelector('span')?.textContent.trim();
        if (this.button.textContent !== label) this.button.textContent = label;
        const price = this.product.querySelector('[id^="price-"] .price--on-sale .price-item--sale') || this.product.querySelector('[id^="price-"] .price-item--regular');
        const priceLabel = this.querySelector('[data-sticky-price]');
        if (price && priceLabel.textContent !== price.textContent.trim()) priceLabel.textContent = price.textContent.trim();
      };
      sync();
      this.mutation = new MutationObserver(sync);
      this.mutation.observe(this.product, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-disabled','data-mm-choice-made']});
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.updateVisibility = () => {
        this.hidden = !this.mobile.matches || !this.pastButton;
        document.body.classList.toggle('mm-sticky-visible', !this.hidden);
      };
      this.mobile.addEventListener('change', this.updateVisibility);
      this.observer = new IntersectionObserver(([entry]) => {
        this.pastButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.updateVisibility();
      });
      this.observer.observe(this.nativeButton);
      this.onClick = () => {
        if (this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true') {
          const picker = this.product.querySelector('variant-selects');
          picker?.scrollIntoView({block:'center', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          const choice = picker?.querySelector('.mm-mobile-variant-chips button:not([disabled])') || picker?.querySelector('select, input');
          choice?.focus({preventScroll:true});
          return;
        }
        this.nativeButton.click();
      };
      this.button.addEventListener('click', this.onClick);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.mutation?.disconnect(); this.mobile?.removeEventListener('change', this.updateVisibility); this.button?.removeEventListener('click', this.onClick); document.body.classList.remove('mm-sticky-visible'); }
  }
  class MMQuickChoice extends HTMLElement {
    connectedCallback() {
      this.onChange = event => {
        if (event.target.name !== 'id') return;
        const select = event.target;
        const option = select.selectedOptions[0];
        const button = this.querySelector('button[type="submit"]');
        button.disabled = !select.value || option.disabled;
        const quantity = this.querySelector('[name="quantity"]');
        quantity.value = option.dataset.min || '1';
        const price = this.closest('.mm-basket-card').querySelector('[data-mm-card-price]');
        if (option.dataset.price) price.textContent = option.dataset.price;
      };
      this.addEventListener('change', this.onChange);
    }
    disconnectedCallback() { this.removeEventListener('change', this.onChange); }
  }
  customElements.define('mm-quick-choice', MMQuickChoice);
  customElements.define('mm-sticky-atc', MMStickyATC);
  const initializeChoices = () => {
    document.querySelectorAll('product-info').forEach(product => {
      if (product.dataset.mmChoiceInitialized) return;
      product.dataset.mmChoiceInitialized = 'true';
      const button = product.querySelector('.product-form__submit[data-mm-explicit-choice="true"]');
      const picker = product.querySelector('variant-selects');
      if (!button || !picker) return;
      product.dataset.mmChoiceMade = 'false';
      const select = [...picker.querySelectorAll('select')].find(select => select.options.length > 1);
      if (select) {
        const selected = select.selectedOptions[0];
        const placeholder = new Option(button.querySelector('span').textContent.trim(), '', true, true);
        placeholder.disabled = true;
        placeholder.setAttribute('selected', 'selected');
        placeholder.dataset.optionValueId = selected.dataset.optionValueId;
        selected.removeAttribute('selected');
        select.prepend(placeholder);
        select.value = '';
      }
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    });
  };
  const initializeMobileChips = () => {
    document.querySelectorAll('main product-info').forEach(product => {
      const picker = product.querySelector('variant-selects');
      picker?.querySelectorAll('select').forEach(select => {
        if (select.parentElement.classList.contains('mm-native-select-with-chips')) return;
        const options = [...select.options].filter(option => option.value && option.dataset.optionValueId);
        if (options.length === 1) select.closest('.product-form__input')?.classList.add('mm-single-choice');
        if (options.length < 2 || options.length > 5) return;
        const chips = document.createElement('div');
        chips.className = 'mm-mobile-variant-chips medium-hide large-up-hide';
        chips.setAttribute('role', 'group');
        chips.setAttribute('aria-label', select.labels?.[0]?.textContent.trim() || select.name);
        options.forEach(option => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = option.textContent.trim();
          button.dataset.optionValueId = option.dataset.optionValueId;
          button.disabled = option.disabled;
          button.setAttribute('aria-pressed', String(option.selected));
          button.addEventListener('click', () => {
            product.dataset.mmChipFocus = option.dataset.optionValueId;
            select.value = option.value;
            select.dispatchEvent(new Event('change', {bubbles: true}));
            chips.querySelectorAll('button').forEach(chip => chip.setAttribute('aria-pressed', String(chip === button)));
          });
          chips.append(button);
        });
        select.parentElement.classList.add('mm-native-select-with-chips');
        select.parentElement.after(chips);
        const focus = product.dataset.mmChipFocus;
        const selectedChip = [...chips.querySelectorAll('button')].find(button => button.dataset.optionValueId === focus);
        if (selectedChip) {
          delete product.dataset.mmChipFocus;
          requestAnimationFrame(() => { if (selectedChip.isConnected) selectedChip.focus({preventScroll: true}); });
        }
      });
    });
  };
  const desktopProductLayout = window.matchMedia('(min-width: 750px)');
  const positionExpandedProductMedia = () => {
    document.querySelectorAll('main product-info .product--mm-expanded').forEach(product => {
      if (product.closest('quick-add-modal')) return;
      const column = product.querySelector(':scope > .mm-product-media-column');
      const media = column?.querySelector(':scope > .product__media-wrapper') || product.querySelector(':scope > .product__media-wrapper');
      const purchase = product.querySelector(':scope > .product__info-wrapper');
      const details = column?.querySelector(':scope > .mm-product-details') || product.querySelector(':scope > .mm-product-details');
      const discovery = purchase?.querySelector(':scope > [data-mm-product-discovery]') || product.querySelector(':scope > [data-mm-product-discovery]');
      if (!media || !purchase || !discovery) return;
      if (desktopProductLayout.matches && !column) {
        const focused = product.contains(document.activeElement) ? document.activeElement : null;
        const mediaColumn = document.createElement('div');
        mediaColumn.className = 'mm-product-media-column';
        product.insertBefore(mediaColumn, media);
        mediaColumn.append(media);
        if (details) mediaColumn.append(details);
        purchase.append(discovery);
        product.classList.add('mm-product-columns-ready');
        if (focused?.isConnected && document.activeElement !== focused) focused.focus({preventScroll: true});
      } else if (!desktopProductLayout.matches && column) {
        const focused = product.contains(document.activeElement) ? document.activeElement : null;
        product.insertBefore(media, purchase);
        if (details) product.append(details);
        product.append(discovery);
        column.remove();
        product.classList.remove('mm-product-columns-ready');
        if (focused?.isConnected && document.activeElement !== focused) focused.focus({preventScroll: true});
      }
    });
  };
  desktopProductLayout.addEventListener('change', positionExpandedProductMedia);
  let discoverySource;
  const positionProductDiscovery = () => {
    positionExpandedProductMedia();
    const slot = document.querySelector('main product-info [data-mm-product-discovery]');
    if (!slot || slot.closest('quick-add-modal') || slot.querySelector('product-recommendations')) return;
    const recommendations = document.querySelector('main product-recommendations.related-products');
    const section = recommendations?.closest('.shopify-section');
    const content = recommendations?.parentElement;
    if (!section || !content || section.contains(slot) || content.contains(slot)) return;
    // Keep the Shopify section wrapper and its editor metadata at template level.
    const anchor = document.createComment('mm-discovery-content-origin');
    content.before(anchor);
    discoverySource = { section, content, anchor };
    slot.append(content);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', positionProductDiscovery, {once: true});
  else positionProductDiscovery();
  document.addEventListener('shopify:section:load', positionProductDiscovery);
  document.addEventListener('shopify:section:unload', event => {
    const source = discoverySource;
    if (!source) return;
    if (event.target === source.section || event.target.contains(source.section)) {
      source.content.remove();
      source.anchor.remove();
      discoverySource = null;
    } else if (event.target.contains(source.content) && source.anchor.isConnected) {
      source.anchor.after(source.content);
    }
  });
  document.addEventListener('shopify:section:select', event => {
    if (event.target === discoverySource?.section && discoverySource.content.isConnected) {
      discoverySource.content.scrollIntoView({block: 'nearest'});
    }
  });
  initializeChoices();
  initializeMobileChips();
  new MutationObserver(() => { initializeChoices(); initializeMobileChips(); positionProductDiscovery(); }).observe(document.body, {subtree:true,childList:true});
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({data:{sectionId,variant}}) => {
      const products = document.querySelectorAll(`product-info[data-section="${CSS.escape(sectionId)}"], product-info[data-original-section="${CSS.escape(sectionId)}"]`);
      products.forEach(product => {
        // Native Quick Add retains the original section ID in its variant event.
        const input = product.querySelector('product-form [name="id"]');
        if (!variant || input?.value !== String(variant.id)) return;
        product.dataset.mmChoiceMade = 'true';
        const button = product.querySelector('.product-form__submit');
        if (button && variant.available) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          button.querySelector('span').textContent = window.variantStrings.addToCart;
        }
      });
    });
  }
})();
